import React, { useEffect, useState } from 'react'
// import StripeTestCards from '../components/StripeTestCards'
import getStripe from 'utilities/stripe'
import { fetchPostJSON } from 'utilities/api'
import styles from './StripeCheckoutButton.module.css'
// import { useRouter } from 'next/router'
import Button from 'components/Button'
import { ButtonVariant } from 'components/Button/Button'

type Props = {
  children: React.ReactNode,
  className?: string,
  tierId: string,
  size?: ButtonVariant,
}

const StripeCheckoutButton = ({
  tierId,
  children = <>Checkout with Stripe</>,
  className = '',
  size = 'large',
}: Props) => {
  const [loading, setLoading] = useState(false)
  // const [tier, setTier] = useState<string>(tierId)
  // const router = useRouter()
  // const tier = router.query.tier as string

  const getCheckoutSession = async (tier: string) => {
    const response = await fetchPostJSON('/api/checkout/sessions', {
      tier,
    })
    console.log('payment setup', { response })

    if (!response) {
      console.error('Checkout Session Error')
      return
    }

    // Redirect to Checkout.
    const stripe = await getStripe()
    if (!stripe) {
      return null
    }
    const { error } = await stripe.redirectToCheckout({
      sessionId: response.id,
    })

    // If `redirectToCheckout` fails due to a browser or network
    // error, display the localized error message to your customer
    // using `error.message`.
    console.warn(error.message)
  }

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault()
    setLoading(true)
    console.log('handleSubmit', { tierId })
    // Create a Checkout Session.
    if (tierId) {
      await getCheckoutSession(tierId)
    }
    setLoading(false)
  }

  // useEffect(() => {
  //   if (tierId) {
  //     getCheckoutSession(tierId)
  //   }
  // }, [tierId])

  return (
    <div className={styles.stripeCheckoutButton}>
      <form onSubmit={handleSubmit}>
        {/* <StripeTestCards /> */}
        <Button
          variant={size}
          type="submit"
          isDisabled={loading}
          className={className}
        >
          { children }
        </Button>
      </form>
    </div>
  )
}

export default StripeCheckoutButton
